import {setUserDepartment} from "../../api/Api";
import {handleNoSession} from "../../util/errorUtils";
import {Select} from "antd";
import {departmentOptions} from "./DepartmentOptions";

export const DepartmentChangeWidget = ({user, onApiFail, onRefresh, refresh, props}) => {
    const onDepartmentChange = (user) => (value, option) => {
        setUserDepartment(user.id, value).then(result => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            handleNoSession(e, onApiFail);
        })
    }

    if (user === undefined) {
        return <div/>
    }
    return <Select defaultValue={user.department} onChange={onDepartmentChange(user)} options={departmentOptions} popupMatchSelectWidth={false} />
}